export const PARAMS_ALLOWED_CHARACTERS = /^[a-zA-Z0-9 _\-.'()]+$/;
export const PARAMS_DISALLOWED_CHARACTERS = /[^a-z0-9 _\-.'()]/g;

export const USERNAME_ALLOWED_CHARACTERS = /^[a-zA-Z0-9_-]+$/;

export const NAME_ALLOWED_CHARACTERS = /^[a-zA-Z]+$/;
